export default __webpack_public_path__ + "bdff224e8d49b7a55e8e9a90e0d31bbe.png";